<script>
  document.title = ('Rantingg | Aviso de Privacidad');
</script>
<div class="container mt-5">
  <div class="jumbotron">
    <h1 class="display-4">Aviso de Privacidad</h1>
    <p class="lead">
      El Aviso de Privacidad forma parte del uso del sitio web <a
        href="http://www.ratingg.com.mx">www.ratingg.com.mx</a
      >
    </p>

    <p>
      En cumplimiento a la Ley Federal de Protección de Datos Personales en
      Posesión de los Particulares, Conversiones, (en adelante Empresa) le
      informa que la Empresa es responsables de sus datos personales. El
      “Usuario” podrá contactar a la Empresa en cualquier momento al correo
      electrónico: david.flores@ratingg.com.mx o directamente en nuestras
      oficinas ubicadas en Avenida General Máximo Rojas 69A, en el Municipio de
      Papalotla, Tlaxcala; C.P. 90790.
    </p>
    <h2>Objeto.</h2>
    <p>
        Este Aviso de Privacidad regula la forma, términos y condiciones conforme a los cuales la Empresa, incluyendo a sus empresas subsidiarias y empresas relacionadas, están facultadas y autorizadas por el Titular para obtener y tratar los datos personales (en lo sucesivo los “Datos”) del Titular.
    </p>
    <p>
        Protegemos y salvaguardamos sus datos personales para evitar el daño, pérdida, destrucción, robo, extravío, alteración, así como el tratamiento no autorizado de sus datos personales.
    </p>
    <h2>Datos Excluidos.</h2>
    <p>
      El sitio web de la Empresa puede incluir enlaces a sitios web de terceros.
      Si obtiene acceso a dichos enlaces, abandonará el sitio web de la Empresa,
      por lo cual la Empresa no asume ninguna responsabilidad en relación con
      esos sitios web de terceros. 
    </p>
    <p>
        Si publica, comenta o comparte información
      personal, incluidas fotografías, en cualquier foro público, red social,
      blog u otro foro de este tipo, debe tener en cuenta que cualquier
      información personal que publique la podrán leer, ver, recabar o utilizar
      otros usuarios de dichos foros, y se podría utilizar para ponerse en
      contacto con usted, enviarle mensajes no solicitados o con fines que ni
      usted ni la Empresa puede controlar. La Empresa no es responsable de la
      información personal que decida enviar a estos foros o redes sociales.
    </p>
    <h2>Datos personales.</h2>
    <p>
      La información deberá ser veraz y completa. El usuario responderá en todo
      momento por los datos proporcionados y en ningún caso la Empresa será
      responsable de la veracidad de los mismos.
    </p>
    <p>
      El Titular proporcionará voluntariamente sus Datos a la Empresa, ya sea
      por escrito, verbalmente, electrónicamente, mediante encuestas, su ingreso
      directo al sitio de Internet de la Empresa o mediante el envío de archivos
      electrónicos o de cualquier otra naturaleza, incluyendo de forma
      enunciativa mas no limitativa, entrega directa de información, acceso al
      sitio de Internet de la Empresa o el de sus clientes o afiliadas (en donde
      se haga referencia a este Aviso de Privacidad), llamadas telefónicas o de
      telemercadeo, solicitudes por correo electrónico, seminarios, congresos o
      eventos, etc.
    </p>
    <p>
      Los datos recabados en el sitio www.ratingg.com.mx son; nombre, apellidos,
      compañía en la que labora o que representa, Estado, Municipio, Código
      Postal, Teléfono, Mail, preferencias comerciales.
    </p>
    <p>
      El Titular acepta que la Empresa también podrá obtener Datos del Titular
      de otros medios, como información que se obtenga de otras fuentes
      comercialmente disponibles, como por ejemplo directorios telefónicos,
      directorios laborales, tarjetas de presentación, bases de datos públicas,
      así como redes sociales de forma enunciativa y no limitativa que se
      encuentran alojadas en dominios de google o Facebook, etc,.
    </p>
    <p>
      Los datos personales que proporcioné en los formularios del sitio web,
      Instagram, LinkedIn, Google+ o Facebook Fan Page de la Empresa, serán
      protegidos en términos de los artículos 3, fracción II, 18, fracción II,
      19, 20, fracción VI, 21, 22 y demás correlativos de la Ley Federal de
      Transparencia y Acceso a la Información Pública Gubernamental, así como
      los artículos 37, 38, 39, 40, 41, 47 y 48 de su Reglamento, y los
      Lineamientos de Protección de Datos Personales.
    </p>
    <p>
      Sus datos personales serán tratados con base a en los principios de
      licitud, consentimiento, información, calidad, finalidad, lealtad,
      proporcionalidad y responsabilidad en términos de la Legislación.
    </p>
    <h2>Datos sensibles.</h2>
    <p>
      El Titular declara bajo protesta de decir verdad, que no ha proporcionado
      y en ningún caso proporcionará a la Empresa “datos personales sensibles”,
      es decir, aquellos datos personales íntimos o cuya utilización debida o
      indebida pueda dar origen a discriminación o conlleve un riesgo grave para
      éste.
    </p>
    <h2>Qué son las cookies y cómo se utilizan.</h2>
    <p>
      En caso de uso de, o acceso a nuestros sitios de Internet u otros medios
      electrónicos, le informamos que es posible que nuestros sistemas recopilen
      Datos del Titular tales como tipo de navegador, sistema operativo, páginas
      de Internet visitadas, dirección IP, etc., a través “cookies” o “web
      beacons”, entre otros. Las cookies son archivos de texto que son
      descargados automáticamente y almacenados en el disco duro del equipo de
      cómputo del usuario al navegar en una página de Internet específica, que
      permiten recordar al servidor de Internet algunos datos sobre este
      usuario, entre ellos, sus preferencias para la visualización de las
      páginas en ese servidor, nombre y contraseña. Por su parte, las web
      beacons son imágenes insertadas en una página de Internet o correo
      electrónico, que puede ser utilizado para monitorear el comportamiento de
      un visitante, como almacenar información sobre la dirección IP del
      usuario, duración del tiempo de interacción en dicha página y el tipo de
      navegador utilizado, entre otros.
    </p>

    <p>
      En el caso de empleo de cookies, el botón de “ayuda” que se encuentra en
      la barra de herramientas de la mayoría de los navegadores, le dirá cómo
      evitar aceptar nuevos cookies, cómo hacer que el navegador le notifique
      cuando recibe un nuevo cookie o cómo deshabilitar todos los cookies.
    </p>
    <h2>Uso de la información.</h2>
    <p>
      Mejora del proceso comercial. - En caso de información estadística, datos
      de tratamiento interno, promociones comerciales, estudios de
      mercadotecnia, ofertas comerciales, encuestas, asuntos publicitarios o
      similares.
    </p>
    <p>
      Estos Datos se usarán para: (i) Proveerle los bienes y/o servicios que ha
      solicitado o respecto de los que ha manifestado interés; (ii) Procurar un
      servicio eficiente y proveer una mejor atención al usuario, así como para
      mejorar su experiencia en el uso de ciertos productos y/o servicios; (iii)
      Enviarle y presentarle bienes y/o servicios que puedan resultar relevantes
      o atractivos, incluyendo su participación en promociones, ofertas y
      campañas de publicidad; (vi) Informar sobre cambios o nuevos productos o
      servicios que estén relacionados con el contratado o adquirido por el
      cliente; (v) Dar cumplimiento a obligaciones contraídas con nuestros
      clientes; (vi) Evaluar la calidad del servicio, o realizar estudios
      internos sobre hábitos de consumo.
    </p>
    <p>
      Información de contacto o laboral.- En caso de ofertas o solicitudes de
      trabajo, presentación de currículos vitae u hojas de vida, expedientes
      laborales o cualquier otro similar, se podrá requerir o entregar Datos
      tales como nombre, domicilio, teléfonos, celulares, fax, correo
      electrónico, fotografías, información sobre grados académicos, lo relativo
      a historial académico y laboral (empleos anteriores) y datos relativos a
      interés en puestos de trabajo, incluyendo aptitudes y capacidades, datos
      de contacto, nivel socioeconómico y pretensiones laborales (incluyendo
      sueldo).
    </p>
    <p>
      Estos Datos se usarán para (i) fines internos de la Empresa, incluyendo el
      conservarlos como expedientes laborales dentro del área de Recursos
      Humanos de la Empresa; (ii) Procesos de contratación laboral o de
      prestación de servicios independientes; (iii) Para efecto de proporcionar
      referencias en caso de que otra persona o empresa solicite informes sobre
      posibles candidatos a un puesto, trabajo o comisión; (iv) Para efectos
      legales internos, incluyendo el cumplimiento de obligaciones de Seguridad
      Social o similares; (v) Para efecto de publicarlos en caso de que se
      requiera como parte de una estrategia de oferta de recursos humanos.
    </p>
    <h2>Limitación de uso y divulgación de información.</h2>
    <p>
      En nuestro programa de notificación de promociones, ofertas y servicios a
      través de correo electrónico, sólo la Empresa tiene acceso a la
      información recabada. Este tipo de publicidad se realiza mediante avisos y
      mensajes promocionales de correo electrónico, los cuales sólo serán
      enviados a usted y a aquellos contactos registrados para tal propósito,
      esta indicación podrá usted modificarla en cualquier momento enviando un
      correo a david.flores@ratingg.com.mx. En los correos electrónicos
      enviados, pueden incluirse ocasionalmente ofertas de terceras partes que
      sean nuestros socios comerciales.
    </p>
    <p>Derechos ARCO (acceso, rectificación, cancelación y oposición)</p>
    <p>
      La persona responsable es David Flores Bautista a quien puede contactar
      mediante el correo david.flores@ratingg.com.mx o directamente en Avenida
      General Máximo Rojas 69A, en el Municipio de Papalotla, Tlaxcala; C.P.
      90790.
    </p>
    <p>Para ejercer sus derechos arco y revocar el consentimiento otorgado.</p>
    <p>
      Como titular de datos personales, el “Usuario” podrá ejercitar los
      derechos ARCO (acceso, cancelación, rectificación y oposición al
      tratamiento de sus datos personales), o bien, revocar el consentimiento
      que haya otorgado a la Empresa, para el tratamiento de sus datos
      personales, enviando directamente su solicitud a David Flores Bautista a
      través de la cuenta de correo electrónico: david.flores@ratingg.com.mx
    </p>
    <p>
      Dicha solicitud deberá contener por lo menos: (a) nombre y domicilio u
      otro medio para comunicarle la respuesta a su solicitud; (b) los
      documentos que acrediten su identidad o, en su caso, la representación
      legal; (c) la descripción clara y precisa de los datos personales respecto
      de los que se solicita ejercer alguno de los derechos ARCO, (d) la
      manifestación expresa para revocar su consentimiento al tratamiento de sus
      datos personales y por tanto, para que no se usen; (d) cualquier otro
      elemento que facilite la localización de los datos personales.
    </p>
    <p>
      Su petición deberá ir acompañada de los fundamentos por los que solicita
      dicha revocación y una identificación oficial del titular de los datos o
      de su apoderado. En un plazo máximo de 20 (veinte) días hábiles
      atenderemos su solicitud y le informaremos sobre la procedencia de la
      misma a través del correo electrónico del que provenga la petición.
    </p>
    <p>
        La cancelación de Datos dará lugar a un periodo de bloqueo tras el cual se procederá a la supresión del Dato. La Empresa podrá conservar los Datos exclusivamente para efectos de las responsabilidades nacidas del tratamiento.
    </p>
    <p>
      La Empresa solicita al usuario que actualice sus datos cada vez que éstos
      sufran alguna modificación, ya que esto permitirá brindarle un servicio
      eficiente y personalizado.
    </p>
    <p>La Empresa no estará obligada a cancelar los Datos cuando:</p>
    <p>
      Deban ser tratados por disposición legal; Obstaculice actuaciones
      judiciales o administrativas vinculadas a obligaciones fiscales, la
      investigación y persecución de delitos o la actualización de sanciones
      administrativas; sean necesarios para proteger los intereses jurídicamente
      tutelados del Titular; Sean necesarios para realizar una acción en función
      del interés público; Sean necesarios para cumplir con una obligación
      legalmente adquirida. Transferencias de información con terceros
    </p>
    <p>
      La Empresa únicamente realiza remisión de datos para cumplir con las
      obligaciones contraídas con los clientes.
    </p>
    <p>
      La Empresa solo compartirá datos cuando haya sido requerido por orden
      judicial para cumplir con las disposiciones procesales.
    </p>
    <h2>Protección.</h2>
    <p>
      Se mantendrá la confidencialidad de sus datos personales estableciendo y
      manteniendo de forma efectiva las medidas de seguridad administrativas,
      técnicas y físicas, para evitar su daño, pérdida, alteración, destrucción,
      uso, acceso o divulgación indebida.
    </p>
    <h2>Cambios en el aviso de privacidad.</h2>
    <p>
      Nos reservamos el derecho de efectuar en cualquier momento modificaciones
      o actualizaciones al presente aviso de privacidad, para la atención de
      novedades legislativas o jurisprudencias, políticas internas, nuevos
      requerimientos para la prestación u ofrecimiento de nuestros servicios o
      productos y prácticas del mercado.
    </p>
    <p>
      Estas modificaciones estarán disponibles al público a través de nuestra
      página de Internet www.ratingg.com.mx, sección aviso de privacidad.
    </p>
    <h2>Aceptación de los términos.</h2>
    <p>
      Esta declaración de Privacidad está sujeta a los términos y condiciones
      del sitio web de la Empresa antes descrito, lo cual constituye un acuerdo
      legal entre el usuario y la Empresa.
    </p>
    <p>
      Si el usuario utiliza los servicios en el sitio de la Empresa, significa
      que ha leído, entendido y acordado los términos antes expuestos y
      constituye una manifestación de su consentimiento para que la Empresa
      realice el tratamiento de sus datos, de conformidad con este Aviso de
      Privacidad.
    </p>
    <h2>Autoridad.</h2>
    <p>
      Si el usuario considera que han sido vulnerados sus derechos respecto de
      la protección de datos personales, tiene el derecho de acudir a la
      autoridad correspondiente para defender su ejercicio. La autoridad es el
      Instituto Federal de Acceso a la Información y Protección de Datos (IFAI),
      su sitio web es: www.ifai.mx.
    </p>

    <h2>Cambios al Aviso de Privacidad.</h2>
    <p>
      La Empresa se reserva el derecho de actualizar periódicamente el presente
      aviso para reflejar los cambios en nuestras prácticas de información. Es
      responsabilidad del Titular revisar periódicamente el contenido del aviso
      en el sitio www.ratingg.com.mx, en donde se publicarán los cambios
      realizados aunado a la fecha de actualización.
    </p>
    <p>
      Se sugiere visitar con frecuencia esta área del sitio, a fin de mantenerse
      oportunamente informado.
    </p>
  </div>
</div>